const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Assessments Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Assessments', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/assessments/:subresource/:subname', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    take: {params: {subresource: 'take'}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    checkIfGrader: {params: {subresource: 'grader'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    duplicate: {params: {subname: 'duplicate'}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);
